const $ = jQuery;

let isLoading = false;
let observer = null;

export default {
    init() {
        setupInfiniteScroll();

        $(document).on('reinitInfiniteScroll', setupInfiniteScroll);
    }
};

function setupInfiniteScroll() {
    const $triggers = $('.infinite-scroll-trigger');

    if (observer) observer.disconnect();

    if (!$triggers.length) return;

    observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !isLoading) {
                loadNextPage($(entry.target));
            }
        });
    }, {
        rootMargin: '400px'
    });

    $triggers.each(function() {
        observer.observe(this);
    });
}

async function loadNextPage($trigger) {
    const $link = $trigger.find('a');
    const url = $link.attr('href');

    if (!$link.length || !url) return;

    isLoading = true;

    const $spinner = $trigger.find('.spinner-wrapper');
    $spinner.removeClass('hidden').addClass('flex opacity-100');

    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const html = await response.text();

        await new Promise(res => setTimeout(res, 800));
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const $parsed = $(doc);

        const targetSelector = $trigger.data('target') || '.infinite-scroll-wrapper';
        const itemSelector = $trigger.data('item') || '> *';

        const $wrapper = $trigger.closest('.block, section, .container').find(targetSelector);
        const $newItems = $parsed.find(targetSelector).find(itemSelector);
        const $newTrigger = $parsed.find('.infinite-scroll-trigger');

        if (!$newItems.length || !$wrapper.length) {
            throw new Error('Target grid elements not found in fetched HTML.');
        }

        const fetchUrlObj = new URL(url, window.location.origin);
        const pageNum = fetchUrlObj.searchParams.get('paged') || fetchUrlObj.pathname.match(/\/page\/(\d+)/)?.[1] || 2;

        $newItems.first().attr('id', `page-${pageNum}`).addClass('scroll-mt-32');

        $newItems.addClass('opacity-0 translate-y-8 transition-all duration-700 ease-out');
        $wrapper.append($newItems);

        $(document).trigger('infiniteScrollAppended', [$wrapper, $newItems]);

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                $newItems.each((index, el) => {
                    setTimeout(() => {
                        $(el).removeClass('opacity-0 translate-y-8');
                    }, index * 150);
                });
            });
        });

        const currentBrowserUrl = new URL(window.location);
        currentBrowserUrl.hash = `page-${pageNum}`;
        window.history.replaceState({}, '', currentBrowserUrl);

        observer.unobserve($trigger[0]);

        if ($newTrigger.length) {
            $trigger.replaceWith($newTrigger);
            observer.observe($('.infinite-scroll-trigger').last()[0]);
        } else {
            $trigger.remove();
        }

    } catch (error) {
        console.error('Infinite Scroll Error:', error);
    } finally {
        isLoading = false;
        $spinner.addClass('hidden').removeClass('flex opacity-100');
    }
}
